export default __webpack_public_path__ + "static/media/banner.a4f47905.png";